module.exports = __webpack_public_path__ + "img/3.993d5c6d.jpeg";